import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { SecretRecord } from "../SecretRecord";

import * as GetOrgSecrets from "./useOrgSecrets";
import * as GetSecretRecord from "./useSecretRecord";
import * as GetSecretValue from "./useSecretValue";

export function useUpdateSecretMutation() {
  const { secretService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<
    SecretRecord,
    Error,
    { secretName: string; newValue: string; orgId: string }
  >({
    mutationFn: async ({ secretName, newValue, orgId }) => {
      return secretService.updateSecret(secretName, newValue, orgId);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: GetSecretValue.getQueryKey(),
      });

      await queryClient.invalidateQueries({
        queryKey: GetOrgSecrets.getQueryKey(),
      });

      await queryClient.invalidateQueries({
        queryKey: GetSecretRecord.getQueryKey(),
      });
    },
  });
}
